module.exports = __webpack_public_path__ + "img/shipped_packages_blue.29621924.svg";